import React from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { Clear, Download } from "@mui/icons-material";
import { createEmptyChart } from "../../services/patternCompiler";
import "./PatternActions.css";

const PatternActions = ({
  patternTitle,
  onPatternTitleChange,
  onSavePattern,
  onClearGrid,
  onExport,
  onSubmitToGallery,
  gridSize,
}) => {
  return (
    <Box className="p-4">
      <Typography variant="h5" color="primary" className="mb-3">
        Pattern Actions
      </Typography>
      <div className="pattern-actions-form">
        <TextField
          label="Pattern Title"
          value={patternTitle}
          onChange={onPatternTitleChange}
          fullWidth
          size="small"
          className="mb-3"
        />

        <div className="d-flex flex-column gap-2">
          <Button
            variant="outlined"
            startIcon={<Clear />}
            onClick={() => {
              if (window.confirm("Are you sure you want to clear the grid? This will remove all stitches from your current chart.")) {
                onClearGrid(createEmptyChart(gridSize.height, gridSize.width));
              }
            }}
            size="small"
            color="secondary"
          >
            Clear Grid
          </Button>

          <Button
            variant="contained"
            startIcon={<Download />}
            onClick={onExport}
            size="small"
            color="secondary"
          >
            Export Pattern
          </Button>

          <Button
            variant="contained"
            onClick={onSubmitToGallery}
            size="small"
            color="primary"
          >
            Submit to Gallery
          </Button>
        </div>
      </div>
    </Box>
  );
};

export default PatternActions;
